'use strict';
var parent = require('../../stable/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/actual/object/keys.js
// module id = 333
// module chunks = 0